(function(){
  function initKalaAmazonBooks(){
    if(!document.body || !document.body.classList.contains('kala-amazon-book')) return;
    document.addEventListener('submit',function(event){
      var form=event.target;
      if(!form || !form.matches) return;
      if(form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')){
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },true);
    var commerce=document.querySelector('[data-kala-book-commerce-section]');
    var aplusHero=document.querySelector('.kap__hero-info');
    if(commerce && aplusHero){
      var blurb=aplusHero.querySelector('.kap__blurb');
      if(blurb){blurb.insertAdjacentElement('afterend',commerce)}else{aplusHero.appendChild(commerce)}
      commerce.classList.add('is-embedded');
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initKalaAmazonBooks,{once:true})}else{initKalaAmazonBooks()}
})();